import PropTypes from "prop-types";
import React, { Component } from "react";
import {
    Container, ScrollableContainer, Text,
} from "../../../../../../components/index";


// class definition
export class SectionDetails extends Component {

    static propTypes = {
        section: PropTypes.any,
    };

    static defaultProps = {
    };

    render() {

        // resolve input
        const { section } = this.props;

        // render view
        return (
            <ScrollableContainer style={styles.scrollableContainer} scrollType="vertical-thin">
                <Container style={Object.assign({}, styles.container, styles.containerSize)}>
                    <Container flex>
                        <Container style={styles.content}>
                            <Text style={styles.title} bold>{section.name}</Text>
                            <Text style={styles.description}>{section.details}</Text>
                        </Container>
                    </Container>
                </Container>
            </ScrollableContainer>
        );
    }
}


const styles = {
    scrollableContainer: {
        padding: 12,
        backgroundColor: "#000000d0",
        height: 162
    },
    container: {
        backgroundColor: "#3c3c3c"
    },
    containerSize: {
        maxWidth: "50%",
        minHeight: 126,
    },
    content: {
        marginHorizontal: 6,
        paddingTop: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 8
    },
    title: {
        marginBottom: 8,
        color: "#fff",
        fontSize: 14,
        letterSpacing: 0.2
    },
    description: {
        color: "#fafafa",
        fontSize: 14
    }
};



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/SectionDetails.js